export default __webpack_public_path__ + "static/media/robot.36b4bd16.png";